import { render, staticRenderFns } from "./Create-Employee.vue?vue&type=template&id=11243ab6"
import script from "./Create-Employee.vue?vue&type=script&lang=js"
export * from "./Create-Employee.vue?vue&type=script&lang=js"
import style0 from "./Create-Employee.vue?vue&type=style&index=0&id=11243ab6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports